import { Sun, Moon } from 'lucide-react';
import { useTheme } from '@/hooks/useTheme';

const ThemeToggle = () => {
  const { theme, toggleTheme } = useTheme();

  return (
    <button
      onClick={toggleTheme}
      className="p-2 rounded-lg bg-light-secondary dark:bg-dark-secondary hover:bg-light-accent dark:hover:bg-dark-accent transition-colors"
      aria-label="Toggle theme"
    >
      {theme === 'light' ? (
        <Moon size={20} className="text-light-text dark:text-dark-text" />
      ) : (
        <Sun size={20} className="text-light-text dark:text-dark-text" />
      )}
    </button>
  );
};

export default ThemeToggle;

